import { Component, ReactNode } from 'react';

import logger from './';

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: Error) {
    logger.error('ca0f7d', 'Client-side Next error', {
      name: error.name,
      message: error.message,
      stack: error.stack,
    });
  }

  override render() {
    if (this.state.hasError) {
      return <h1>Something went wrong</h1>;
    }

    return this.props.children;
  }
}
